module.exports = __webpack_public_path__ + "img/calendario.9011eb73.png";